import { render, staticRenderFns } from "./c-good-list.vue?vue&type=template&id=fc474308&"
import script from "./c-good-list.vue?vue&type=script&lang=js&"
export * from "./c-good-list.vue?vue&type=script&lang=js&"
import style0 from "./c-good-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports